import { isPlatformBrowser } from '@angular/common';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Me-resolve identitas tenant untuk endpoint publik backend.
 *
 * Prioritas backend: slug (X-Tenant / ?tenant) → subdomain (?subdomain) → uuid (?tenantId).
 * Default kita memakai slug dari environment. Bila `resolveFromSubdomain` aktif dan
 * berjalan di browser, subdomain host dipakai (mis. aldorar.contoh.com → "aldorar").
 */
@Injectable({ providedIn: 'root' })
export class TenantService {
	private readonly platformId = inject(PLATFORM_ID);

	/** Subdomain dari host browser, atau null bila tidak relevan / di server. */
	private subdomain(): string | null {
		if (!isPlatformBrowser(this.platformId)) return null;
		const host = window.location.hostname;
		const root = environment.tenant.rootDomain;
		if (!host.endsWith(root)) return null;
		const prefix = host.slice(0, host.length - root.length).replace(/\.$/, '');
		if (!prefix || prefix === 'www') return null;
		return prefix;
	}

	/** Param query tenant untuk endpoint list (tenant wajib). */
	params(extra: Record<string, string | number | undefined | null> = {}): HttpParams {
		let params = new HttpParams();
		const sub = environment.tenant.resolveFromSubdomain ? this.subdomain() : null;
		if (sub) params = params.set('subdomain', sub);
		else params = params.set('tenant', environment.tenant.slug);

		for (const [key, value] of Object.entries(extra)) {
			if (value !== undefined && value !== null && value !== '') {
				params = params.set(key, String(value));
			}
		}
		return params;
	}

	/** Header tenant alternatif (lebih bersih untuk landing per-subdomain). */
	headers(): HttpHeaders {
		const sub = environment.tenant.resolveFromSubdomain ? this.subdomain() : null;
		return sub
			? new HttpHeaders({ 'X-Tenant-Subdomain': sub })
			: new HttpHeaders({ 'X-Tenant': environment.tenant.slug });
	}
}
